<template>
  <footer class="admin-footer block">
    <div class="mx-auto px-2">
      <div class="flex flex-wrap items-center justify-center md:justify-start">
        <div class="w-full px-2">
          <div class="text-xs text-blueGray-500 font-semibold text-center md:text-left">
            Copyright © {{ date }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
};
</script>
